/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetComponentContextResponseDto } from './AssetComponentContextResponseDto';
import {
    AssetComponentContextResponseDtoFromJSON,
    AssetComponentContextResponseDtoFromJSONTyped,
    AssetComponentContextResponseDtoToJSON,
    AssetComponentContextResponseDtoToJSONTyped,
} from './AssetComponentContextResponseDto';
import type { AssetComponentControllerResponseDto } from './AssetComponentControllerResponseDto';
import {
    AssetComponentControllerResponseDtoFromJSON,
    AssetComponentControllerResponseDtoFromJSONTyped,
    AssetComponentControllerResponseDtoToJSON,
    AssetComponentControllerResponseDtoToJSONTyped,
} from './AssetComponentControllerResponseDto';
import type { AssetComponentLookupResponseDto } from './AssetComponentLookupResponseDto';
import {
    AssetComponentLookupResponseDtoFromJSON,
    AssetComponentLookupResponseDtoFromJSONTyped,
    AssetComponentLookupResponseDtoToJSON,
    AssetComponentLookupResponseDtoToJSONTyped,
} from './AssetComponentLookupResponseDto';

/**
 * 
 * @export
 * @interface AssetComponentResponseDto
 */
export interface AssetComponentResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetComponentResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetComponentResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssetComponentResponseDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetComponentResponseDto
     */
    assetId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetComponentResponseDto
     */
    assetContextId: string;
    /**
     * 
     * @type {AssetComponentContextResponseDto}
     * @memberof AssetComponentResponseDto
     */
    assetContext?: AssetComponentContextResponseDto | null;
    /**
     * OCPP role discriminator: connector | controller
     * @type {string}
     * @memberof AssetComponentResponseDto
     */
    componentType?: string | null;
    /**
     * OCPP connector index (1, 2, 3, …)
     * @type {number}
     * @memberof AssetComponentResponseDto
     */
    connectorId?: number | null;
    /**
     * OCPP charge-box / controller identity
     * @type {string}
     * @memberof AssetComponentResponseDto
     */
    ocppId?: string | null;
    /**
     * FK to the controller ComponentSchema
     * @type {string}
     * @memberof AssetComponentResponseDto
     */
    controllerId?: string | null;
    /**
     * 
     * @type {AssetComponentControllerResponseDto}
     * @memberof AssetComponentResponseDto
     */
    controller?: AssetComponentControllerResponseDto | null;
    /**
     * 
     * @type {string}
     * @memberof AssetComponentResponseDto
     */
    parentComponentId?: string | null;
    /**
     * 
     * @type {AssetComponentLookupResponseDto}
     * @memberof AssetComponentResponseDto
     */
    parentComponent?: AssetComponentLookupResponseDto | null;
    /**
     * 
     * @type {AssetComponentLookupResponseDto}
     * @memberof AssetComponentResponseDto
     */
    componentClass?: AssetComponentLookupResponseDto | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetComponentResponseDto
     */
    installedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetComponentResponseDto
     */
    removedAt?: Date | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AssetComponentResponseDto
     */
    attributes?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetComponentResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetComponentResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the AssetComponentResponseDto interface.
 */
export function instanceOfAssetComponentResponseDto(value: object): value is AssetComponentResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('assetContextId' in value) || value['assetContextId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function AssetComponentResponseDtoFromJSON(json: any): AssetComponentResponseDto {
    return AssetComponentResponseDtoFromJSONTyped(json, false);
}

export function AssetComponentResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetComponentResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'assetContextId': json['assetContextId'],
        'assetContext': json['assetContext'] == null ? undefined : AssetComponentContextResponseDtoFromJSON(json['assetContext']),
        'componentType': json['componentType'] == null ? undefined : json['componentType'],
        'connectorId': json['connectorId'] == null ? undefined : json['connectorId'],
        'ocppId': json['ocppId'] == null ? undefined : json['ocppId'],
        'controllerId': json['controllerId'] == null ? undefined : json['controllerId'],
        'controller': json['controller'] == null ? undefined : AssetComponentControllerResponseDtoFromJSON(json['controller']),
        'parentComponentId': json['parentComponentId'] == null ? undefined : json['parentComponentId'],
        'parentComponent': json['parentComponent'] == null ? undefined : AssetComponentLookupResponseDtoFromJSON(json['parentComponent']),
        'componentClass': json['componentClass'] == null ? undefined : AssetComponentLookupResponseDtoFromJSON(json['componentClass']),
        'installedAt': json['installedAt'] == null ? undefined : (new Date(json['installedAt'])),
        'removedAt': json['removedAt'] == null ? undefined : (new Date(json['removedAt'])),
        'attributes': json['attributes'] == null ? undefined : json['attributes'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function AssetComponentResponseDtoToJSON(json: any): AssetComponentResponseDto {
    return AssetComponentResponseDtoToJSONTyped(json, false);
}

export function AssetComponentResponseDtoToJSONTyped(value?: AssetComponentResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'serialNumber': value['serialNumber'],
        'assetId': value['assetId'],
        'assetContextId': value['assetContextId'],
        'assetContext': AssetComponentContextResponseDtoToJSON(value['assetContext']),
        'componentType': value['componentType'],
        'connectorId': value['connectorId'],
        'ocppId': value['ocppId'],
        'controllerId': value['controllerId'],
        'controller': AssetComponentControllerResponseDtoToJSON(value['controller']),
        'parentComponentId': value['parentComponentId'],
        'parentComponent': AssetComponentLookupResponseDtoToJSON(value['parentComponent']),
        'componentClass': AssetComponentLookupResponseDtoToJSON(value['componentClass']),
        'installedAt': value['installedAt'] == null ? value['installedAt'] : value['installedAt'].toISOString(),
        'removedAt': value['removedAt'] == null ? value['removedAt'] : value['removedAt'].toISOString(),
        'attributes': value['attributes'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

